import React from 'react';
import { useFeature } from '@nextiva/feature-toggle';
import { GlobalHeader } from './GlobalHeader';
import { SimpleHeader } from './SimpleHeader';
import { flags } from '../../constants';

export const GlobalHeaderWithHookContainer = ({
  children,
  globalStoreData,
  firstName,
  lastName,
  appName,
  canShowWaffleMenu,
  showLogo,
  canShowCalendar,
  avatarMenuOptions,
  onSignOut,
  ...props
}) => {
  const { isReady, isEnabled } = useFeature({
    name: flags.globalNavigation,
  });

  if (!isReady) {
    return null;
  }

  if (isEnabled) {
    return (
      <GlobalHeader
        appName={appName}
        globalStoreData={globalStoreData}
        firstName={firstName}
        lastName={lastName}
        hasWaffleMenu={canShowWaffleMenu}
        showLogo={showLogo}
        avatarMenuOptions={avatarMenuOptions}
        hasCalendar={canShowCalendar}
        onSignOut={onSignOut}
      >
        {children}
      </GlobalHeader>
    );
  }

  return <SimpleHeader {...props} />;
};
